import Modal from 'components/Modal/Modal';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { resendOtp, resendSignupOtp, signupOtp } from 'reduxStore/actions/auth';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { validation } from '../../ResetPassword/constants/text';
import RoundedButton from 'components/RoundedButtons';
import { setDialogState } from 'reduxStore/reducers/dialogSlice';
import { toast } from 'react-toastify';

const LoginOtp = () => {
  const dispatch = useDispatch();
  const [otpArray, setOtpArray] = useState(Array(6).fill(''));
  const inputRefs = useRef([]);
  const [timer, setTimer] = useState(60);
  const [canResend, setCanResend] = useState(false);
  const { dialogOpenState } = useSelector((state) => state.dialogOpenState);

  const email = localStorage.getItem('signupEmail');

  const handleOtpChange = (index, value) => {
    const newOtp = [...otpArray];
    newOtp[index] = value.slice(-1);
    setOtpArray(newOtp);

    if (formikOTP.errors.otp) {
      formikOTP.setFieldError('otp', '');
    }

    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
    const updatedOtp = [...otpArray];
    updatedOtp[index] = value.slice(-1);
    formikOTP.setFieldValue('otp', updatedOtp.join(''));
  };

  const formikOTP = useFormik({
    initialValues: {
      otp: '',
    },
    validationSchema: Yup.object({
      otp: Yup.string()
        .matches(/^\d{6}$/, validation.otp)
        .required(validation.otp_require),
    }),
    onSubmit: () => {},
  });

  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }
    if (timer === 0) {
      setCanResend(true);
    }
    return () => clearInterval(interval);
  }, [timer]);

  const formatTime = (seconds) => {
    const m = String(Math.floor(seconds / 60)).padStart(2, '0');
    const s = String(seconds % 60).padStart(2, '0');
    return `${m}:${s}`;
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !otpArray[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const paste = e.clipboardData.getData('text');
    const digits = paste.replace(/\D/g, '').slice(0, 6);

    const newOtpValues = [...otpArray];
    for (let i = 0; i < 6; i++) {
      newOtpValues[i] = digits[i] || '';
    }
    setOtpArray(newOtpValues);
    formikOTP.setFieldValue('otp', newOtpValues.join(''));
    if (formikOTP.errors.otp) {
      formikOTP.setFieldError('otp', '');
    }
  };

  const handleSubmit = () => {
    const otp = otpArray.join('');
    const email = localStorage.getItem('signupEmail');
    formikOTP.setFieldError('otp', '');
    if (otp.length !== 6) {
      formikOTP.setFieldError(
        'otp',
        validation.otp_require || 'Please enter the 6-digit OTP'
      );
      return;
    }
    if (!email) {
      formikOTP.setFieldError('otp', 'Email not found. Please try again.');
      return;
    }
    const clearOtp = () => {
      setOtpArray(Array(6).fill(''));
      formikOTP.setFieldValue('otp', '');
      formikOTP.setFieldError('otp', '');
      inputRefs.current[0]?.focus();
    }
  
    dispatch(signupOtp({ email, otp }))
      .unwrap()
      .then((res) => {
        dispatch(
          setDialogState({
            ...dialogOpenState,
            logIn: false,
            register: false,
            isLoggedIn: false,
            isLoginOtp: false,
          })
        );
        toast.success(res?.message || 'OTP Verified Successfully');
      })
      .catch((err) => {
 
        toast.error(err?.message || 'Error verifying OTP');
        const message = typeof err === 'string' ? err : 'Invalid OTP. Please try again.';
        formikOTP.setFieldError('otp', message);
        clearOtp();
      });
  };

  const handleResendOtp = async () => {
    const email = localStorage.getItem('signupEmail') || '';
    if (!email) {
      console.error('Email is required to resend OTP');
      return;
    }
    const clearOtp = () => {
      setOtpArray(Array(6).fill(''));
      formikOTP.setFieldValue('otp', '');
      formikOTP.setFieldError('otp', '');
      inputRefs.current[0]?.focus();
    }
 
    try {
      const resultAction = await dispatch(resendSignupOtp({ email }));
      setTimer(60);
      setCanResend(false);
      if (resendSignupOtp.fulfilled.match(resultAction)) {
        clearOtp();
      } else {
        console.error('Resend failed:', resultAction.payload);
        clearOtp();
      }
    } catch (error) {
     
      console.error('Unexpected error:', error);
      clearOtp();
    }
  };
  const closeModal = () => {
   
    dispatch(
      setDialogState({
        ...dialogOpenState,
        logIn: false,
        register: false,
        isLoginOtp: false,
      })
    );
  };

  return (
    <Modal
      title='Enter OTP'
      modalContentClassname={'sm:min-w-[490px] max-h-[90vh] overflow-y-auto sidebar-scrollbar '}
      closeHandler={closeModal}
      disableOutsideClick={true}
      text={`Please enter the 6-digit OTP Verification sent to ${email}.`}
    >
      <div className='flex justify-between gap-2 mb-4'>
        {[0, 1, 2, 3, 4, 5].map((index) => (
          <input
            key={index}
            ref={(el) => (inputRefs.current[index] = el)}
            type='text'
            maxLength='1'
            value={otpArray[index]}
            onChange={(e) => handleOtpChange(index, e.target.value)}
            onKeyDown={(e) => handleKeyDown(index, e)}
            onPaste={handlePaste}
            className={`w-9 h-9 sm:w-12 sm:h-12 bg-[#F0F0F0] border-none text-xl text-center rounded-md transition-colors ${
              formikOTP.errors.otp
                ? 'border-red-500 focus:border-red-500'
                : 'border-gray-300 focus:border-blue-500'
            } focus:ring-2 focus:ring-blue-200`}
          />
        ))}
      </div>

      {formikOTP.errors.otp && (
        <div className='text-[12px] md:text-[14px] text-red text-start '>
          {formikOTP.errors.otp}
        </div>
      )}

      <div className='text-center text-white font-medium mt-2'>
        {canResend ? (
          <button
            onClick={handleResendOtp}
            type='button'
            className='text-black'
          >
            Didn't receive code?{' '}
            <span className='underline text-primary'>Resend</span>
          </button>
        ) : (
          <div className='text-black'>{formatTime(timer)}</div>
        )}
      </div>

      <RoundedButton
        className='xl:mt-5 md:mt-4 mt-4 mb-6 w-full font-semibold justify-center'
        isWidthFull={true}
        text={'Submit'}
        type='button'
        onClick={handleSubmit}
      />

      <RoundedButton
        className='w-full font-semibold justify-center !bg-gray-1 bg-opacity-35 text-gray-3'
        isWidthFull={true}
        text={'Cancel'}
        type='button'
        onClick={closeModal}
      />
    </Modal>
  );
};

export default LoginOtp;
